<template>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="section-title">{{ $t("Show Date wise Admits Report") }}</div>
        <div class="mt-3 mb-2">
          <div class="row">
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="dropdown-curve-container">
                             <label
                               :class="
                                 dropDown.selectedCinema &&
                                 dropDown.selectedCinema.hasOwnProperty('cine_id')
                                   ? 'shift-up'
                                   : 'font-weight-bold'
                               "
                               >{{ $t("select") }} {{ $tc("cinema") }}</label
                             >
                             <multiselect
                               :disabled="isRoleID"
                               :options="dropDown.cinemas"
                               v-model="dropDown.selectedCinema"
                               :searchable="true"
                               label="cine_name"
                               track-by="cine_id"
                               placeholder=""
                               @input="onSelectCinema($event)"
                               :allowEmpty="false"
                               :showLabels="false"
                             ></multiselect>
                           </div>
            </div>
  
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <button class="btn-clearDate" v-if="fromDate">✖</button>
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                   
                  >
                  </Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    {{ $t("select") }}
                    {{ $t("Date") }}
                  </label>
                </div>
              </div>
            </div>
  
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <button class="btn-clearDate" v-if="toDate">✖</button>
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                    :not-after="disabledAfter"
                    :disabledDates="{ from: new Date(Date.now()) }"
                  >
                  </Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    {{ $t("select") }}
                    {{ $t("Date") }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-2 align-self-center mb-3">
              <button
                class="btn-blue-lg w-100"
                @click.prevent="getShowDetailsData({ isPdf: 'N',isExcel:'N' })"
              >
                {{ $t("fetch") }}
                {{ $t("report") }}
              </button>
            </div>
  
            <div
              class="col-lg-6 col-xl-12 align-self-center mb-2 d-flex justify-content-end align-items-center"
              v-if="showDetailsData.length > 0"
            >
              <div class="mx-1">{{ $t("download") }} as:</div>
  
              <!-- <span
                @click="getShowDetailsData({ isPdf: 'Y',isExcel:'N' })"
                title="Download as Pdf"
              >
                <img src="@/assets/img/icons/pdf.svg" height="25" width="25" />
              </span> -->
              <span
                @click="getShowDetailsData({ isPdf:'N',isExcel: 'Y' })"
                title="Download as Excel"
              >
                <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
              </span>
              <!-- <span @click="excelDownload()" title="Download as Excel">
                <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
              </span> -->
            </div>
          </div>
        </div>
  
        <div>
          <div v-if="showDetailsData.length>0"
                style="overflow-x: scroll; width: auto !important">
            <table
              class="swc-report-table"
              border="1"
              id="myTable"
            >
              <thead class="bg-lightgrey font-weight-bold">
                <tr>
                  <th >
                    {{ $tc("Cinema Name") }}
                  </th>
                  <th >
                    {{ $t("Show Date") }}
                  </th>               
                  <th >
                    {{ $tc("Total Shows") }}
                  </th>
  
                  <th>{{ $t("Total Admits") }}</th>
  
                </tr>     
              </thead>
              <tbody>
            <template v-for="(cinema, cinemaIndex) in showDetailsData" >
            <tr >
                <td colspan="4" class="concession_blue font-weight-bold">{{ cinema.cinema_name }}</td>
            </tr>
            <tr v-for="(show, showIndex) in cinema.cinemaShowsData">
                <td class="text-left">{{ show.cinema_name }}</td>
                <td class="text-left">{{ show.show_date }}</td>
                <td class="text-right">{{ show.total_shows }}</td>
                <td class="text-right">{{ show.total_admits }}</td>
            </tr>
            <tr  class="font-weight-bold" style="background-color: rgb(232, 232, 232)">
                <td class="text-left" colspan="2">Total</td>
                <td class="text-right">{{cinema.total_shows}}</td>
                <td class="text-right">{{cinema.total_admits}}</td>
            </tr>
            </template>
            <tr  class="bg-lightgrey font-weight-bold">
                <td class="text-left" colspan="2">Grand Total</td>
                <td class="text-right">{{grandTotal.total_shows}}</td>
                <td class="text-right">{{grandTotal.total_admits}}</td>
            </tr>
              </tbody>
            </table>
          </div>
          <div  v-if="showDetailsData.length == 0" style="overflow-x: scroll; width: auto !important">
            <table
              class="swc-report-table"
              border="1"
             
            >
              <thead class="bg-lightgrey font-weight-bold">
                <tr>
                    <th >
                    {{ $tc("Cinema Name") }}
                  </th>
                  <th >
                    {{ $t("Show Date") }}
                  </th>            
                  <th >
                    {{ $tc("Total Shows") }}
                  </th>
  
                  <th >{{ $t("Total Admits") }}</th>
  
                </tr> 
            
              </thead>
              <tbody>
                <tr>
                  <td colspan="4">
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import NewReportService from "../../../services/NewReportService";
  import FnBReportService from "@/services/FnBReportsService";
  import PosFnbService from "@/services/PosFnbService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import xlsx from "json-as-xlsx";
  import { mapState, mapGetters, mapActions } from "vuex";
  
  export default {
    components: {
      NoRecords,
    },
    computed: {},
    data() {
      return {
        showNegative: "Y",
        showNegativeWatchers: "Y",
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        
        showDetailsData: [ ],
        fromDate: new Date(),
        toDate: new Date(),
        disabledAfter: new Date(),
        grandTotal : {},
        disabledDates: {
          from: "",
        },
      };
    },
    beforeMount() {
      // let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
      this.fromDate = new Date();
    },
    watch:{
fromDate: function(value) {
  this.disabledDates.from = new Date(
    moment(this.fromDate).format("YYYY"),
    parseFloat(moment(this.fromDate).format("MM")) - 1, 
    1
  );
  this.toDate = moment(this.fromDate).add(7, 'days').format("YYYY-MM-DD");
}
},

    mounted() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      this.getCinemaList(cinemaId);
    },
  
    methods: {
      getCinemaList: function () {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = [...data.Records];
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },

 onSelectCinema: function (event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.dropDown.selectedCinemaAddres = event.cine_address;
        this.$store.dispatch("selectDropdownCinema", event);
        this.getCinemaScreens();
        this.getMovieOverAllAnalysisReport("N", "N", true);

      },
     async getShowDetailsData({isPdf,isExcel}){
        let loader = this.$loading.show();
        try{
       
            let payload={
                  cinema_id: this.dropDown.selectedCinemaId,
            cinema_name: this.dropDown.selectedCinemaName,
            cinema_address: this.dropDown.selectedCinemaAddres,
                fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
                toDate: moment(this.toDate).format("YYYY-MM-DD"),
                isPdf,
                isExcel,
            }
            console.log("payload",payload)
            let response=await NewReportService.GetShowDateWiseAdmits(payload);

            const {data}=response;
            if(data.status && data.Records.length){
                this.showDetailsData = data.Records
                this.grandTotal = data.grandTotal
                if(data.pdfPath && isPdf=="Y"){
                    window.open(data.pdfPath,"_blank");
                }
                if (data.excelPath && isExcel == "Y") {
                    window.open(data.excelPath, "_blank");
                }
            }
            else {
            this.$toasted.show(data.message);
          }

        }
        catch(error){
            console.log(error)
        }
        finally{
           if(loader){
            loader.hide()
           }
        }
      }
    
    },
  };
  </script>
  
  <style scoped>
  .left-border {
    border-left: 1px solid black !important;
    border-top: 0 !important;
    border-bottom: 1px solid black !important;
    border-right: 0 !important;
  }
  
  .right-border {
    border-left: 0 !important;
    border-top: 0 !important;
    border-right: 1px solid black !important;
    border-bottom: 1px solid black !important;
  }
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }
  
  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }
  
  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }
  
  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }
  
  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }
  
  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }
  
  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }
  
  .swc-report-table td {
    white-space: nowrap;
  }
  
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }
  
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .borderOnly {
    border-left: 0px !important;
    border-top: 0px !important;
    border-bottom: 0px !important;
    border-right: 1px !important;
  }
  
  .no_border {
    border: 0px !important;
  }

  .concession_blue {
  background-color: #c5d6f0 !important;
}
  </style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/showDetailsReport.vue